import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { tap } from 'rxjs';
import { EscalaService } from 'src/app/services/escala/escala.service';
import { SugestaoService } from 'src/app/services/regras/sugestao/sugestao.service';

@Component({
  selector: 'app-suggest-rule',
  templateUrl: './suggest-rule.component.html',
  styleUrls: ['./suggest-rule.component.scss'],
})
export class SuggestRuleModalComponent implements OnInit {

  constructor(
    private modalCtrl: ModalController,
    private escalaService: EscalaService,
    private sugestaoService: SugestaoService
  ) { }

  suggest: string = '';
  @Input() escalaId!: number;

  ngOnInit() { }

  close() {
    this.modalCtrl.dismiss();
  }

  suggestSubmit() {
    if (this.suggest.trim().length == 0 || !this.escalaId) return;
    this.sugestaoService.sugerirRegraPost(this.suggest, this.escalaId!).pipe(
      tap((r) => {
        this.modalCtrl.dismiss({
          suggest: this.suggest
        })
      })
    ).subscribe()
  }

}
